import { useState, useEffect, useRef, useCallback } from 'react'

import { useUsers } from '../api/users'
import Page from '../components/Page'

const UsersPage = () => {
  const [users, setUsers] = useState([])
  const { fetchUsers } = useUsers()

  useEffect(() => {
    fetchUsers().then((users) => {
      setUsers(users)
    })
  }, [])

  return (
    <Page>
      <div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Név
                </th>
                <th scope="col" className="px-6 py-3">
                  Email cím
                </th>
                <th scope="col" className="px-6 py-3">
                  Account
                </th>
                <th scope="col" className="px-6 py-3">
                  Legutóbbi belépési link
                </th>
                <th scope="col" className="px-6 py-3">
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {users &&
                users.map((user) => {
                  return (
                    <tr className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                      <td className="px-6 py-2">{user.name}</td>
                      <td className="px-6 py-2">{user.email_address}</td>
                      <td className="px-6 py-2">{user.account_name}</td>
                      <td className="px-6 py-2">{user.last_token}</td>
                      <td className="px-6 py-2 text-right">
                        <a
                          href="#"
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          Edit
                        </a>
                      </td>
                    </tr>
                  )
                })}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  )
}

export default UsersPage
